import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {UserSignalStore} from '../../../store/user/user.signal-store';

@Component({
  selector: 'ucs-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrls: ['./legal-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe]
})

export class LegalNoticeComponent {
  readonly userSignalStore = inject(UserSignalStore);
}
